import { useState } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors, fontSizes, fontWeights } from '@/styles'

const Text = styled.p`
  color: ${colors.regular};
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.regular};
  margin: 0 0 5px;
  transition: all 0.2s ease-in-out;
  white-space: pre-line;
  word-break: break-word;
  width: 100%;
`

const ReadMore = styled(Text)<{
  align?: string
}>`
  color: ${colors.link};
  margin: 0 0 0 auto;
  font-weight: ${fontWeights.medium};
  text-align: ${props => (props.align ? props.align : 'right')};
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;
  :hover {
    opacity: 0.7;
  }
`

interface Props {
  maxChar: number
  description: string
  align?: string
}

const ReadMoreText: React.FC<Props> = ({
  maxChar = 100,
  description = '',
  align
}) => {
  const { t } = useTranslation()
  const [showAll, setShowAll] = useState(false)
  const substring = description?.substring(0, maxChar)
  const isLongerThanMax = description?.length > substring?.length
  const value = showAll
    ? description
    : substring?.concat(isLongerThanMax ? '...' : '')
  const handleClick = () => setShowAll(!showAll)

  return (
    <>
      <Text>{value}</Text>
      {isLongerThanMax && (
        <ReadMore align={align} onClick={handleClick}>
          {showAll
            ? t('b.components.read_more_text.read_less.text', 'Read less')
            : t('b.components.read_more_text.read_more.text', 'Read more')}
        </ReadMore>
      )}
    </>
  )
}

export default ReadMoreText
